<mat-card>
    <mat-card-header>
        <mat-card-title-group>
            <mat-card-title>
                <h2 id="paymentSearchDialogTitle">Invoice Information</h2>
            </mat-card-title>
        </mat-card-title-group>
    </mat-card-header>
    <mat-card-content>
        <div class="info-icon-cell">
            <i class="material-icons">info_outline</i>
        </div>
        <div class="info-description-cell">
            Look for either a Revenue ID/Receivable ID number or a Transaction ID number on your invoice.
            Select the ID type below that is shown on your invoice. If both ID Type numbers are shown,
            select "Transaction ID".
        </div>
            <form [formGroup]="form">
                <div class="form-fields-container">
                    <span id="searchTypeLabel" class="invoice-id-label">Select Invoice ID Type:</span>
                    <mat-radio-group formControlName="searchType" class="invoice-id-radio-group" aria-labelledby="searchTypeLabel">
                        <div *ngFor="let type of searchTypes; let i=index;" class="field-checkbox">
                            <mat-radio-button [id]="'radio'+i" [value]="type">
                                {{type}}
                            </mat-radio-button>
                        </div>
                    </mat-radio-group>
                    <mat-form-field *ngIf="searchType == 'Receivable ID'" appearance="outline">
                        <mat-label>Receivable ID</mat-label>
                        <input (paste)="(false)" id="receivableID" type="number" matInput formControlName="receivableID">
                    </mat-form-field>
                    <mat-form-field *ngIf="searchType == 'Receivable ID'" appearance="outline">
                        <mat-label>Re-enter Receivable ID</mat-label>
                        <input (paste)="(false)" id="reenterReceivableID" type="number" matInput formControlName="checkReceivableID">
                    </mat-form-field>
                    <mat-form-field *ngIf="searchType == 'Transaction ID'" appearance="outline">
                        <mat-label>Transaction ID</mat-label>
                        <input (paste)="(false)" id="transactionID" type="number" matInput formControlName="transactionID">
                    </mat-form-field>
                    <mat-form-field *ngIf="searchType == 'Transaction ID'" appearance="outline">
                        <mat-label>Re-enter Transaction ID</mat-label>
                        <input (paste)="(false)" id="reenterTransactionID" type="number" matInput formControlName="checkTransactionID">
                    </mat-form-field>
                </div>
            </form>
        <br />
        <div>
            Customers who choose to pay multiple receivables at one time can do so in batches of 20 receivables.
            The system cannot process more than 20 receivables at a one time.
            <br/>
        </div>
    </mat-card-content>
    <mat-dialog-actions align="end">
        <button *ngIf="enableSearch()" mat-flat-button id="continue_btn" (click)="continueClick()" [disabled]="searchInProgress" aria-label="Continue">
            <mat-progress-spinner *ngIf="searchInProgress" diameter="20" mode="indeterminate" class="progress-spinner"></mat-progress-spinner>
            Continue
        </button>
        <button *ngIf="enableSearch()" mat-flat-button id="reset_btn" (click)="resetClick()" aria-label="Reset">Reset</button>
        <button mat-flat-button id="close_btn" (click)="closeDialog()" aria-label="Cancel">Cancel</button>
    </mat-dialog-actions>
</mat-card>

